import { useEffect } from "react";
import { useMap } from "react-leaflet";

function MapAutoMove({ position }) {
    const map = useMap();
    useEffect(() => {
        if (position) {
            map.flyTo(position, 15, { duration: 0.8 })
        }
    }, [position]);
    return null;
}
export default MapAutoMove;